import React, {Component} from 'react';
import './Home.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {b64toBlob, showAxiosError} from "../../util/Helpers";
import FileSaver from "file-saver";
import {Label} from "reactstrap";
// import _ from "lodash";

class DocumentDownloadPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading: false,
            currentUser: null,
            fileList: [],
        };
        this.RightExists = this.RightExists.bind(this);
        this.listFiles = this.listFiles.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    componentDidMount() {
        this.listFiles();
        this.setState({currentUser: this.props.currentUser, memberInfo: this.props.currentUser.member});
    }

    RightExists(searchItem) {
        let exists = false;
        const authorities = this.props.authorities;
        for (const authority of authorities) {
            if (authority.authority.includes(searchItem)) {
                exists = true;
            }
        }
        return exists;
    }

    listFiles() {
        let self = this;
        self.setState({
            isLoading: true,
        });
        let params = {
            url: API_BASE_URL + "/uye/list-pdfs/",
            method: 'get'
        };

        request(params).then(function (response) {

            self.setState({
                fileList: response.data,
                isLoading: false,
            });
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({
                isLoading: false,
            });
        });


    }

    handleDownload(selectedItem) {
        let self = this;
        self.setState({
            isLoading: true,
        });
        let params = {
            url: API_BASE_URL + "/uye/watermarked-pdf/",
            method: 'post',
            data: selectedItem
        };
        if (!self.state.memberInfo || !self.state.memberInfo.tcKimlikNo) {
            showAxiosError({message: "Üyelik Bilgisi Bulunamadı!"})
            return;
        }

        request(params).then(function (response) {
            const data = response.data.substring(response.data.indexOf(',') + 1);
            let blob = b64toBlob(data, 'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, selectedItem.replace(".pdf", "") + "_" + self.state.memberInfo.tcKimlikNo + ".pdf");
            self.setState({
                isLoading: false,
                showButton: false,
                hesCode: null
            });
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({
                isLoading: false,
            });
        });
    }


    render() {

        return (
            <div className="home-container">
                {(this.state.isLoading) && <div className="loader"><LoadingIndicator/></div>}
                <div className="page-content">
                    <div className="row col-sm-12">
                        <table>

                            {this.state.fileList && this.state.fileList.map((item) =>
                                <tr key={"wqewqe"}>
                                    <td>
                                        <Label className="row col-sm-6"><b>{item}</b></Label>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => {
                                                this.handleDownload(item)
                                            }}
                                            style={{background: "rgb(239, 118, 125)", color: "white"}}
                                            className="row col-sm-4">İNDİR
                                        </button>
                                    </td>
                                </tr>
                            )
                            }
                        </table>

                        <div/>
                    </div>

                </div>
            </div>

        );
    }

}


export default DocumentDownloadPage;



// WEBPACK FOOTER //
// ./src/page/home/DocumentDownloadPage.js